import { render, staticRenderFns } from "./ChartAggregationForm.vue?vue&type=template&id=4a2aabe8"
import script from "./ChartAggregationForm.vue?vue&type=script&lang=js"
export * from "./ChartAggregationForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports